
export default function LoaderBlack(){
    return(
        <span class="loaderBlack loader"></span>
    )
}